import { Accessory } from '../accessory';

export class ConfigurationAccessory {
  accessoryId: number;
  accessory: Accessory;

  constructor(accessory: Accessory) {
    this.accessoryId = accessory.id;
    this.accessory = accessory;
  }
}
